import React, { useEffect, useState, useRef } from 'react';
import { PlusIcon, MinusIcon, HelpCircleIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Y si nunca he hecho Reiki?',
  a: 'No necesitas experiencia previa. La formación comienza desde cero y te guía paso a paso desde los fundamentos hasta la práctica avanzada.'
}, {
  q: '¿Y si no soy "espiritual"?',
  a: 'Reiki no requiere creencias religiosas. Es una técnica estructurada de trabajo energético que cualquier persona puede aprender y aplicar.'
}, {
  q: '¿Y si quiero solo sanar y no trabajar de esto?',
  a: 'Perfecto. Primero sanas tú. Luego decides si deseas profesionalizarte. La formación te sirve en ambos casos, sin presión.'
}, {
  q: '¿Cuánto tiempo tengo para completar la formación?',
  a: 'El acceso es de por vida. Puedes avanzar a tu propio ritmo, sin fechas límite ni presiones. El material siempre estará disponible.'
}, {
  q: '¿Puedo practicar Reiki en otras personas?',
  a: 'Sí. La formación incluye técnicas para aplicar Reiki tanto en ti mismo como en otras personas, de forma presencial o a distancia.'
}, {
  q: '¿El material es descargable?',
  a: 'Sí, todo el contenido es 100% digital y descargable. Puedes acceder desde cualquier dispositivo: celular, tablet o computadora.'
}, {
  q: '¿Qué pasa si no me convence?',
  a: 'Contás con una garantía de devolución. Si dentro del período de garantía sentís que no es para vos, te devolvemos el 100% del dinero.'
}, {
  q: '¿Necesito materiales o herramientas especiales?',
  a: 'No. Solo necesitas el material de la formación y disposición para practicar. No se requieren cristales, velas ni ningún elemento adicional.'
}];
function AccordionItem({
  faq,
  isOpen,
  onToggle
}: {
  faq: {
    q: string;
    a: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);
  return <div className={`border rounded-2xl bg-[#1e1e30] overflow-hidden transition-all duration-300 ${isOpen ? 'border-[#d4a017]/50 shadow-lg' : 'border-white/5 hover:border-white/20'}`} data-id="element-147">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-6 text-left" data-id="element-148">
        <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-[#f0c040]' : 'text-gray-200'}`} data-id="element-149">
          {faq.q}
        </span>
        <span className={`flex-shrink-0 ml-4 p-1 rounded-full transition-colors ${isOpen ? 'bg-[#d4a017]/20 text-[#f0c040]' : 'bg-white/5 text-gray-400'}`} data-id="element-150">
          {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-151" /> : <PlusIcon className="w-5 h-5" data-id="element-152" />}
        </span>
      </button>
      <div ref={contentRef} style={{
      maxHeight: height
    }} className="overflow-hidden transition-all duration-300 ease-in-out" data-id="element-153">
        <div className="px-6 pb-6 text-gray-400 text-lg leading-relaxed border-t border-white/5 pt-4 bg-[#1a1a2e]/50" data-id="element-154">
          {faq.a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1a1a2e] py-14 md:py-20 px-4 border-t border-white/5" data-id="element-155">
      <div className="container mx-auto max-w-6xl" data-id="element-156">
        <div className="text-center mb-10" data-id="element-157">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-white/5 rounded-full mb-4 text-gray-400" data-id="element-158">
            <HelpCircleIcon className="w-6 h-6" data-id="element-159" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight" data-id="element-160">
            ¿Tienes dudas? Aquí las respondemos
          </h2>
        </div>

        <div ref={ref1} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-4 ${vis1 ? 'is-visible' : ''}`} data-id="element-161">
          {FAQS.map((faq, idx) => <AccordionItem key={idx} faq={faq} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-162" />)}
        </div>
      </div>
    </section>;
}